import consumer from "./consumer";


// const scrollToBottom = () => {
//   if (document.getElementById('messages')) {
//     const messages = document.getElementById('messages');
//     messages.scrollTop = messages.scrollHeight;
//   }
// }


const initGroupCable = () => {
  const messageheadersContainer = document.getElementById('message_headers');

  if (messageheadersContainer) {
    const id = messageheadersContainer.dataset.groupId;
    const user = messageheadersContainer.dataset.userId;

    consumer.subscriptions.create({ channel: "GroupChannel", id: id }, {
      received(data) {
        if (data["message_to_delete"]) {
          if (data["type"] === `submessage`) {
            const messageToDestroy = document.getElementById(`submessage-${data["id_to_delete"]}`)
            messageToDestroy.querySelector('.trix-content').innerHTML = "<div style='font-style:italic;'>Messsage supprimé</div>";
            messageToDestroy.querySelector('.elements-to-answer-reply-destroy').style.display = 'none';
          } else {
            const messageToDestroy = document.getElementById(`message_header-${data["id_to_delete"]}`)
            messageToDestroy.querySelector('.trix-content').innerHTML = "<div style='font-style:italic;'>Messsage supprimé</div>";
            messageToDestroy.querySelector('.elements-to-answer-reply-destroy').style.display = 'none';
          }
        } else if (data["type"] === `submessage`) {
          if (data["current_user_id"]  === parseInt(user, 10)) {
            const submessagesContainer = document.getElementById(`message_header-${data["message_header_id"]}`);
            submessagesContainer.insertAdjacentHTML('beforeend', data["body"]);
          } else {
            const submessagesContainer = document.getElementById(`message_header-${data["message_header_id"]}`);
            submessagesContainer.insertAdjacentHTML('beforeend', data["body_not_current_user"]);
          }
        } else {
          if (data["current_user_id"]  === parseInt(user, 10)) {
            messageheadersContainer.insertAdjacentHTML('beforeend', data["body"]);
            // $('#message_content').val('');
            $("#message_headers").animate({ scrollTop: 20000000 }, "slow");
          } else {
            messageheadersContainer.insertAdjacentHTML('beforeend', data["body_not_current_user"]);
            // $('#message_content').val('');
            $("#message_headers").animate({ scrollTop: 20000000 }, "slow");
          }
        }
              },
    });
  }
}

export { initGroupCable };

